import { HttpClient,HttpBackend,HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, from , switchMap  } from 'rxjs';
import { map } from 'rxjs/operators'
import { EnvService } from '../../../core/env.service';
import { RuleAppliedPropertyDTO  } from '../../model/RuleAppliedPropertyDTO';
import { RuleAppliedDTO  } from '../../model/RuleAppliedDTO';
import {TestQueryBuilderFilterRule} from '../../model/TestQueryBuilderFilterRule';
import { FilterResultDTO } from '../../model/FilterResultDTO';
import { FilterDTO } from '../../model/FilterDTO';
import { OptionDTO } from '../../model/OptionDTO';
import { QueryBuilderFilterRuleDTO } from '../../model/QueryBuilderFilterRuleDTO';
import { AuthService } from '../../../core/auth-service.component';
import { SummaryDTO } from '../../model/SummaryDTO';

@Injectable()
export class CodingService {
    constructor(private _httpClient: HttpClient,public _env: EnvService,
        private _httpClientBackend: HttpClient,
        private _httpHandler: HttpBackend,private _authService: AuthService) {
        this._httpClientBackend = new HttpClient(_httpHandler); //using this var will now show the loader 
    }
    GetUnAppliedRules(): Observable<Array<RuleAppliedPropertyDTO>> {
        return this._httpClient.get<Array<RuleAppliedPropertyDTO>>(this._env.apiRule +'Coding/GetUnAppliedRules')
        .pipe(map((res: Array<RuleAppliedPropertyDTO>) => res));
    }
    GetCurrency(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetCurrency?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCurrencyByFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetCurrencyFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetInvoiceStatus(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetInvoiceRateStatus?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetInvoiceStatusByFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetInvoiceRateStatusFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    EditFilter(clientCode:string): Observable<Array<any>> {
        return this._httpClient.get<Array<OptionDTO>>(this._env.apiRule +'Coding/editFilter?clientCode='+clientCode)
        .pipe(map((res: Array<OptionDTO>) => res));
    }
    GetInvoiceIdsListDropDown(clientName:string,page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetInvoiceIds?clientName='+clientName+'&&page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetAllInvoiceIdsListDropDown(clientName:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetAllInvoiceIds?clientName='+clientName,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    // Client here ........

    GetClientId(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetClientId?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientIdByFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetClientIdByFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientCode(page:number = 0, pageSize:number = 10): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetCTClientName?page='+page+'&&pageSize='+pageSize, {headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)}).pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientCodeByFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetCTClientNameByFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientRegion(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetClientRegion?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientRegionByFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetClientRegionByFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCTClientCountry(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetClientCountry?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCTClientCountryByFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetClientCountryFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCTClientCity(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetCTClientCity?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCTClientCityByFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetCTClientCityByFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientCity(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetClientCity?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCTClientParentName(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetClientParent?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCTClientParentNameByFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetClientParentByFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCTClientFullName(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetClientFullName?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCTClientFullNameByFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetClientFullNameByFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientDivision(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetClientDiv?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientDivisionFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetClientDivFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientSubDivision(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetClientSubDiv?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetClientSubDivisionFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetClientSubDivFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        })    )
    }
    GetClientLocation(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetClientLoc?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientLocationFilter(page:number, pageSize:number,filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetClientLocFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientSubLocation(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetClientSubLoc?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientSubLocationFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetClientSubLocFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientCountryCode(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetClientCountry?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientCountryCodeFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetClientCountryFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientCountyCode(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetClientCounty?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientCountyCodeFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetAllClientCountyFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetUOM(): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetUOM',{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    //Carrier here.............
    GetCarrierID(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetCarrierId?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetCarrierIDFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetCarrierIdFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierShortName(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetCarrierShortName?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierShortNameFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetCarrierShortNameFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierFullName(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetCarrierFullName?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierFullNameFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetCarrierFullNameFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierRegion(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetCarrierRegion?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierRegionFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetCarrierRegionFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierSCAC(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetCarrierSCAC?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierSCACFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetCarrierSCACFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierLocation(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetCarrierLoc?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierLocationFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetCarrierLocFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierSubLocation(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetCarrierSubLoc?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierSubLocationFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetCarrierSubLocFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierCurrency(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetCarrierCurrency?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierCurrencyFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetCarrierCurrencyFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierCountryCode(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetCarrierCountry?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierCountryCodeFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetCarrierCountryFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierCity(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetCarrierCity?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierCityFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetCarrierCityFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierPostCode(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetCarrierPostCode?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierPostCodeFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetCarrierPostCodeFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientCarrierId(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetClientCarrierId?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientCarrierIdFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetClientCarrierIdFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientCarrierGP1(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetClientCarrierGP1?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientCarrierGP1Filter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetClientCarrierGP1Filter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientCarrierGP2(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetClientCarrierGP2?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientCarrierGP2Filter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetClientCarrierGP2Filter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetShipMode(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetShipmentMode?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetShipModeFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetShipmentModeFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetSrvceType(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetServiceType?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetSrvceTypeFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetServiceTypeFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetFreightTerm(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetFreightTerms?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetFreightTermFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetFreightTermsFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCountryCode(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetCountry?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCountryCodeFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetCountryFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetGeoPortCode(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetPortCode?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetGeoPortCodeFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetPortCodeFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetGeoPostCode(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetPostCode?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetGeoPostCodeFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetPostCodeFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetShipmentOriginState(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetShipmentState?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetShipmentOriginStateFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetShipmentStateFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetShipmentCity(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetShipmentCity?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetShipmentCityFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetShipmentCityFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetAccessorialName(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetAccessorial?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetAccessorialNameFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Coding/GetAccessorial?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        })  )
    }
    GetAppliedRulesByFilterId(filterId:Number): Observable<Array<RuleAppliedDTO>> {
        return this._httpClient.get<Array<RuleAppliedDTO>>(this._env.apiRule +'Coding/GetAppliedRulesByFilterId?filterId='+filterId)
        .pipe(map((res: Array<RuleAppliedDTO>) => res));
    }
    GetFilterById(id: Number) {
        return this._httpClient.get<FilterDTO>(this._env.apiRule +'Coding/GetFilterById?id='+id)
        .pipe(map((res: FilterDTO) => res)); 
    }


    GetFilterLineWithChild(id: Number) {
        return this._httpClient.get<any>(this._env.apiRule +'Coding/GetFilterLineById?id='+id)
        .pipe(map((res: any) => res));
    }
    GetFilterLineByFilterId(id: Number) {
        return this._httpClient.get<any>(this._env.apiRule +'Coding/GetFilterLineByFilterId?id='+id)
        .pipe(map((res: any) => res));
    }
    SaveFilter(data:QueryBuilderFilterRuleDTO): Observable<any> {
        return this._httpClient.post<QueryBuilderFilterRuleDTO>(this._env.apiRule +'Coding/SaveFilter',data)
        .pipe(map((res: any) => res));
    }
    TestRules(data:TestQueryBuilderFilterRule): Observable<TestQueryBuilderFilterRule> {
        return this._httpClient.post<TestQueryBuilderFilterRule>(this._env.apiRule +'Coding/GetInvoicesByIds',data)
        .pipe(map((res: TestQueryBuilderFilterRule) => res));
    }
    GetFilterByClient( page:number,pageSize:number,clientCode:string ){
        return this._httpClient.get<any>(this._env.apiRule +'Coding/GetFilterByClient?page='+page+'&&pageSize='+pageSize+'&&clientCode='+clientCode)
        .pipe(map((res: any) => res));
    }
    GetExportRule(data:any): Observable<any> {
        return this._httpClient.post<any>(this._env.apiRule +'Coding/GetExportRule',data)
        .pipe(map((res: any) => res));
    }

    //shipments here
    GetAllAccessorial():Observable<any> {
        return this._httpClient.get<any>(this._env.apiRule +'Coding/GetAllAccessorial')
        .pipe(map((res: any) => res));
    }
    GetClientField(clientCode:string):Observable<any> {
        return this._httpClient.get<any>(this._env.apiRule +'Coding/GetClientField?clientCode='+clientCode)
        .pipe(map((res: any) => res));
    }
    GetSID():Observable<any> {
        return this._httpClient.get<any>(this._env.apiRule +'Coding/GetSID')
        .pipe(map((res: any) => res));
    }
    ManualTest(data:any): Observable<any> {
        return this._httpClient.post<any>(this._env.apiRule +'Coding/ManualTest',data)
        .pipe(map((res: any) => res));
    }
    DeleteRules(data:any): Observable<any> {
        return this._httpClient.post<any>(this._env.apiRule +'Coding/DeleteRules',data)
        .pipe(map((res: any) => res));
    }
    DisplaySummaryCount(data:SummaryDTO): Observable<any> {
        return this._httpClient.post<any>(this._env.apiRule +'Coding/SummaryCount',data)
        .pipe(map((res: any) => res));
    }
    GetFilterByFilterId(filterIds:string):Observable<any> {
        return this._httpClient.get<any>(this._env.apiRule +'Coding/GetFilterByFilterId?filterIds='+filterIds)
        .pipe(map((res: any) => res));
    }

    SaveTemplate(data:any): Observable<any> {
        return this._httpClient.post<any>(this._env.apiRule +'Coding/SaveTemplate',data)
        .pipe(map((res: any) => res));
    }

    UpdateTemplate(data:any): Observable<any> {
        return this._httpClient.post<any>(this._env.apiRule +'Coding/UpdateTemplate',data)
        .pipe(map((res: any) => res));
    }

    GetTemplate(page:number, pageSize:number, filter:string){
        return this._httpClient.get<any>(this._env.apiRule +'Coding/GetTemplate?pageNo='+page+'&&pageSize='+pageSize+'&&filter='+filter)
        .pipe(map((res: any) => res));
    }

    GetTemplateByName( name:string){
        return this._httpClient.get<any>(this._env.apiRule +'Coding/GetTemplateByName?name='+name)
        .pipe(map((res: any) => res));
    }

    DeleteTemplate(data:any): Observable<any> {
        return this._httpClient.get<any>(this._env.apiRule +'Coding/DeleteTemplate?name='+data)
        .pipe(map((res: any) => res));
    }
}